import { useRef, useEffect, RefObject, ForwardedRef } from 'react';

export const useCombinedRefs = <T>(
  ...refs: ForwardedRef<T>[]
): RefObject<T | null> => {
  const targetRef = useRef<T | null>(null);

  useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  });

  return targetRef;
};
